import React from "react";
import { useTranslation } from "react-i18next";

import Layout from "../../../components/v2/Layout";
import LawList from "../../../components/v2/LeisRegulamentadoras/LawList";
import PageTitle from "../../../components/v2/PageTitle";

import style from "./styles.module.scss";

const keyI18n = "translations.regulatoryLaws";

export default function LeisRegulamentadoras() {
  const { t } = useTranslation();

  return (
    <Layout title={t(`${keyI18n}.title`)}>
      <div className={style.body}>
        <PageTitle
          subtitle={t(`${keyI18n}.subtitle`)}
          title={t(`${keyI18n}.title`)}
        />
        <LawList />
      </div>
    </Layout>
  );
}
